import api from '@/services/api'
import { useAuthStore } from '@/store/authStore'

export interface UserProfile {
  id: string
  email: string
  name?: string | null
  role?: 'owner' | 'admin' | 'agent' | 'viewer'
  tenantId?: string
  profileImageUrl?: string | null
  backgroundImageUrl?: string | null
}

export interface UpdateProfileData {
  name?: string
}

export interface ChangePasswordData {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}

export const profileApi = {
  /**
   * Get current user profile
   */
  async getProfile(): Promise<UserProfile> {
    const { data } = await api.get<{ user: UserProfile; tenant: { id: string } | null }>('/auth/me')
    return {
      ...data.user,
      tenantId: data.tenant?.id,
    }
  },

  /**
   * Update current user profile
   * Note: This uses the /users/:id endpoint.
   */
  async updateProfile(profileData: UpdateProfileData): Promise<UserProfile> {
    const { user } = useAuthStore.getState()
    if (!user?.id) {
      throw new Error('User not authenticated')
    }

    const updatePayload: { name?: string } = {}
    if (profileData.name) {
      updatePayload.name = profileData.name
    }

    const { data } = await api.put<{ success: boolean; user: UserProfile }>(
      `/users/${user.id}`,
      updatePayload
    )

    return data.user
  },

  /**
   * Change user password
   * Note: This endpoint needs to be implemented on the backend
   */
  async changePassword(passwordData: ChangePasswordData): Promise<void> {
    await api.post('/auth/change-password', {
      currentPassword: passwordData.currentPassword,
      newPassword: passwordData.newPassword,
    })
  },

  /**
   * Delete own account and data (Meta compliance & GDPR self-service)
   */
  async deleteAccount(password: string): Promise<void> {
    await api.delete('/users/me', {
      data: { password },
    })
  },
}


